<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/PoOjeh/tc-custom/9781634868457.jpg?1723406934713" alt="This image is the cover for the book Framed for Murder"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Framed for Murder
      </h1>
      <p class="bookDescription body article font2">
        <p>My name is Charlie English. I'm thirty-eight and homeless, so when a man offered me forty bucks to deliver a message and another forty when I had, I jumped at the chance. I shouldn't have. I walked into the house -- and a murder scene -- barely getting away before the cops arrived.<br/><br/>I needed to get out from under the frame, and knew a private detective who might be willing to help me. There’s one problem, though. He’s my ex-lover, which could make things dicey.<br/><br/>He’s less than happy to see me when I show up at his office ... until I tell him why I’m there. That piques his interest. Now it’s a case of finding out who the dead man was, who killed him, and proving it wasn't me. Can we succeed ... while dealing with our renewed interest in each other?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Edward Kendrick
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b2a76a22